import React from 'react';
import './manage-pet-support.scss';
import classNames from 'classnames';
import { contactPath } from '../../../util/config';

export default function ManagePetSupport({
  className = '',
  restoreText,
  supportText,
  supportLink,
  onUndoClick,
  onClick,
}: {
  className?: string;
  restoreText?: string;
  supportText: string;
  supportLink: string;
  onUndoClick?: () => void;
  onClick?: () => void;
}) {
  const managePetSupportClasses = classNames('manage-pet-support', className, {
    'manage-pet-support__column': restoreText !== undefined,
  });

  return (
    <div className={managePetSupportClasses}>
      <span className="manage-pet-support__prompt">{supportText}&nbsp;</span>
      {restoreText && (
        <button
          className="manage-pet-support__restore"
          data-testid="manage-pet-support-restore"
          onClick={onUndoClick}
        >
          {restoreText}
        </button>
      )}
      <a
        className="manage-pet-support__link"
        data-testid="manage-pet-support-link"
        href={contactPath}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
      >
        {supportLink}
      </a>
    </div>
  );
}
